import React, { useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import EntityCard from './Subcomponents/EntityCard'
import Style from '../details.module.css'

/**
 * Pairs each source entity with its same-named target entity so one card can show
 * both directions. Entities that exist on only one side still get a card, with 0
 * for the missing direction.
 */
const mergeEntities = (sourceEntity, targetEntity) => {
    const merged = sourceEntity.map((source) => {
        const match = targetEntity.find((target) => target.entityName === source.entityName)
        return {
            entityName: source.entityName,
            sourceCount: source.totalCount,
            targetCount: match ? match.totalCount : 0
        }
    })

    const targetOnly = targetEntity
        .filter((target) => !sourceEntity.some((source) => source.entityName === target.entityName))
        .map((target) => ({
            entityName: target.entityName,
            sourceCount: 0,
            targetCount: target.totalCount
        }))

    return merged.concat(targetOnly)
}

const BusinessEntities = (props) => {
    const sourceEntity = props.businessEntitiesSource || []
    const targetEntity = props.businessEntitiesTarget || []

    const entities = useMemo(
        () => mergeEntities(sourceEntity, targetEntity),
        [sourceEntity, targetEntity]
    )

    const history = useHistory()

    const viewDetails = () => {
        localStorage.setItem('summaryInfo', JSON.stringify({
            sourceShortName: props.sourceShortName,
            targetShortName: props.targetShortName,
            instancesId: props.instancesId,
            sourceEntity,
            targetEntity,
            sourceId: props.sourceId,
            targetId: props.targetId
        }))
        history.push('/ViewSummary')
    }

    return (
        <>
            <div className={`card-header ${Style.cardHeader}`}>
                <div className={Style.cardHeaderTitle}>
                    <span>Business Entities</span>
                    <span className={Style.countChip}>{entities.length}</span>
                </div>
                <button
                    type="button"
                    className={Style.linkButton}
                    disabled={entities.length === 0}
                    title={entities.length === 0 ? 'Installation setup is incomplete' : 'View entity summary'}
                    onClick={viewDetails}
                >
                    View Details <i className="uil-angle-right" aria-hidden="true" />
                </button>
            </div>

            <div className={`card-body ${Style.entityBody}`}>
                {entities.length === 0 ? (
                    <div className={Style.emptyState}>
                        <i className={`uil-database ${Style.emptyIcon}`} aria-hidden="true" />
                        <p className={Style.emptyText}>No business entities yet</p>
                        <p className={Style.emptyHint}>They appear once the connector setup is complete.</p>
                    </div>
                ) : (
                    <div className="row">
                        {entities.map((entity) => (
                            <EntityCard
                                key={entity.entityName}
                                entityName={entity.entityName}
                                sourceCount={entity.sourceCount}
                                targetCount={entity.targetCount}
                                sourceShortName={props.sourceShortName}
                                targetShortName={props.targetShortName}
                            />
                        ))}
                    </div>
                )}
            </div>
        </>
    )
}

export default BusinessEntities
